import { defineComponent, computed, createElementBlock, openBlock, createElementVNode, withDirectives, createCommentVNode, normalizeClass, createBlock, createVNode, createTextVNode, mergeProps, toDisplayString, renderSlot, vShow } from "vue";
import _sfc_main$2 from "../../components/FlowIcon.vue.js";
import _sfc_main$1 from "../../components/FlowIconButton.vue.js";
import ProjectIcon from "../../icon-library/ProjectIcon.vue.js";
const _hoisted_1 = { class: "sidebar-group-item" };
const _hoisted_2 = {
  key: 0,
  class: "sidebar-heading-chevron"
};
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "sidebar-heading-link-title" };
const _hoisted_5 = { class: "contents" };
const _hoisted_6 = {
  key: 0,
  class: "action-menu"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SidebarElement",
  props: {
    item: {},
    isActive: { type: Boolean },
    hasChildren: { type: Boolean },
    open: { type: Boolean },
    resolvePage: { type: Function }
  },
  emits: ["select", "toggleOpen"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const linkProps = computed(() => {
      var _a;
      const item = props.item;
      if (item.type === "Link")
        return {
          href: item.link,
          rel: "noopener noreferrer",
          target: "_blank"
        };
      if (item.type === "Page")
        return {
          href: ((_a = props.resolvePage) == null ? void 0 : _a.call(props, item.uid)) || "#"
        };
      return {};
    });
    function handleClick() {
      if (props.item.type === "Link") return;
      if (props.item.type === "Folder") {
        emit("toggleOpen");
        return;
      }
      emit("select");
    }
    function handleToggleOpen() {
      if (props.item.type === "Folder") return;
      emit("toggleOpen");
    }
    return (_ctx, _cache) => {
      var _a, _b, _c;
      return openBlock(), createElementBlock("li", _hoisted_1, [
        createElementVNode("div", {
          class: normalizeClass(["sidebar-heading", {
            "active_page": _ctx.isActive,
            "sidebar-group-item__folder": _ctx.item.type === "Folder"
            /* Folder */
          }]),
          onClick: handleClick
        }, [
          _ctx.hasChildren || _ctx.item.type === "Folder" ? (openBlock(), createElementBlock("p", _hoisted_2, [
            createVNode(_sfc_main$1, {
              class: "toggle-nested-icon",
              icon: _ctx.open ? "ChevronDown" : "ChevronRight",
              label: "Toggle group",
              variant: "text",
              width: "20px",
              onClick: handleToggleOpen
            }, null, 8, ["icon"]),
            _cache[1] || (_cache[1] = createTextVNode("   "))
          ])) : createCommentVNode("", true),
          createElementVNode("a", mergeProps({ class: "sidebar-heading-link flex-1" }, linkProps.value, {
            onClick: _cache[0] || (_cache[0] = (e) => _ctx.item.type === "Link" ? e.stopPropagation() : e.preventDefault())
          }), [
            ((_b = (_a = _ctx.item) == null ? void 0 : _a.icon) == null ? void 0 : _b.src) ? (openBlock(), createElementBlock("p", _hoisted_3, [
              createVNode(ProjectIcon, {
                class: "sidebar-icon",
                src: _ctx.item.icon.src
              }, null, 8, ["src"]),
              _cache[2] || (_cache[2] = createTextVNode("   "))
            ])) : createCommentVNode("", true),
            createElementVNode("p", _hoisted_4, toDisplayString(_ctx.item.title.trim() || _ctx.item.type), 1)
          ], 16),
          ((_c = _ctx.item) == null ? void 0 : _c.type) === "Link" ? (openBlock(), createBlock(_sfc_main$2, {
            key: 1,
            class: "link-icon",
            icon: "ExternalLink",
            width: "16px"
          })) : createCommentVNode("", true)
        ], 2),
        withDirectives(createElementVNode("div", _hoisted_5, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 512), [
          [vShow, _ctx.open]
        ]),
        _ctx.$slots["action-menu"] ? (openBlock(), createElementBlock("div", _hoisted_6, [
          renderSlot(_ctx.$slots, "action-menu", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=SidebarElement.vue2.js.map
